/* Form-scoped integration with Nitro addFetchFrom. No separate cart request. */
(function () {
  'use strict';
  if (window.kmBuyNowInstalled) return;
  window.kmBuyNowInstalled = true;
  try { sessionStorage.removeItem('km_buy_now'); } catch (_) {}
  var active = null;
  var forwarding = null;

  function message(form, text) {
    var box = form.querySelector('[data-km-buy-now-error]');
    if (box) { box.textContent = text; box.hidden = !text; }
  }
  function stop(event) { event.preventDefault(); event.stopImmediatePropagation(); }
  function release(state) {
    state.button.disabled = false;
    state.button.removeAttribute('aria-busy');
    if (active === state) active = null;
    if (state.form._kmBuyNow === state) delete state.form._kmBuyNow;
  }

  document.addEventListener('click', function (event) {
    var target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    var cartButton = target.closest('[data-atc-form], [data-action-atc]');
    var buyButton = target.closest('[data-km-buy-now]');
    if (active && (cartButton || buyButton)) {
      if (cartButton === forwarding) { forwarding = null; return; }
      stop(event); return;
    }
    if (!buyButton) return;
    stop(event);
    var form = buyButton.closest('form[data-type="add-to-cart-form"]');
    if (!form) return;
    var atc = form.querySelector('[data-atc-form]');
    message(form, '');
    if (!atc || atc.disabled || atc.hasAttribute('aria-disabled')) {
      message(form, 'Lütfen stokta olan bir ürün ve varyant seçin.'); return;
    }
    if (!window.BEEconfigs || !window.BEEconfigs.enableAjaxATC ||
        !window.BEEThemeSP || window.BEEThemeSP.isEditCartReplace) {
      message(form, 'Bu işlem şu anda kullanılamıyor. Sepete Ekle butonunu kullanabilirsiniz.'); return;
    }
    // Avoid racing an ordinary add which was already started.
    if (document.querySelector('[data-atc-form].is--loading, [data-action-atc].is--loading')) {
      message(form, 'Lütfen devam eden sepet işleminin tamamlanmasını bekleyin.'); return;
    }
    if (!form.reportValidity()) return;
    var variant = new FormData(form).get('id');
    if (!variant || !/^\d+$/.test(String(variant))) {
      message(form, 'Lütfen ürün seçeneklerini tamamlayın.'); return;
    }
    var state = {
      form: form, button: buyButton, started: false, httpOK: false,
      accepted: false, rejected: false,
      accept: function (response) {
        if (response && response.status && Number(response.status) >= 400 && Number(response.status) < 500) {
          state.rejected = true;
          message(form, typeof response.description === 'string' ? response.description : 'Ürün sepete eklenemedi. Stok ve seçenekleri kontrol edin.');
          return;
        }
        if (!state.httpOK || !response || response.status ||
            String(response.variant_id || response.id) !== String(variant)) {
          state.fail(); return;
        }
        state.accepted = true;
        var root = window.BEEThemeSP.root_url || '/';
        var checkout = new URL(root.replace(/\/?$/, '/') + 'checkout', window.location.origin);
        if (checkout.origin !== window.location.origin) { state.accepted = false; state.fail(); return; }
        window.location.assign(checkout.href);
      },
      fail: function () {
        message(form, 'İşlemin sonucu doğrulanamadı. Tekrar eklemeden önce sepetinizi kontrol edin ve sayfayı yenileyin.');
      },
      finish: function () {
        // Clean only this request; do not close a quick-view dialog on error.
        atc.classList.remove('is--loading');
        atc.removeAttribute('aria-disabled');
        atc.querySelectorAll('.loading-overlay__spinner, .bee-svg-spinner').forEach(function (spinner) { spinner.hidden = true; });
        if (form._kmBuyNow === state) delete form._kmBuyNow;
        if (state.rejected) release(state);
        // Keep the lock after success or an uncertain network result: never retry automatically.
      }
    };
    active = state;
    form._kmBuyNow = state;
    buyButton.disabled = true;
    buyButton.setAttribute('aria-busy', 'true');
    forwarding = atc;
    try { atc.click(); }
    catch (_) { state.fail(); }
    finally { forwarding = null; }
    if (!state.started) {
      release(state);
      message(form, 'Ürün seçeneklerini ve gerekli alanları kontrol edin. İşlem başlamadıysa Sepete Ekle butonunu kullanabilirsiniz.');
    }
  }, true);

  document.addEventListener('submit', function (event) {
    if (active && event.target.matches('form[data-type="add-to-cart-form"]')) stop(event);
  }, true);
})();